var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"mt-2 tabName"},[_c('h3',[_vm._v(_vm._s(_vm.$t('create_custom_medication')))])]),_c('CustomMedicationForm',{key:_vm.formKey,attrs:{"customMedication":_vm.customMedication,"submitButtonName":"create_custom_medication"},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }